import { NgModule } from '@angular/core';
import { VafFineDetailComponent } from './vaf-fine-detail.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { VafFineCardComponentModule } from '../../components/vaf-fine-card/vaf-fine-card.component.module'
@NgModule({
    declarations: [
        VafFineDetailComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTooltipModule,
        MatProgressBarModule,
        VafFineCardComponentModule
    ],
    exports: [
        VafFineDetailComponent
    ]
})
export class VafFineDetailComponentModule { }